var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.filterList.length > 1)?_c('div',{staticClass:"wf-filter-wrap"},_vm._l((_setup.filterList),function(item,index){return _c('div',{key:index,staticClass:"wf-filter-item",class:{
			'wf-filter-item--active': _setup.filterValue === item.value
		},on:{"click":function($event){return _setup.handleFilterCheck(item.value)}}},[_c('span',[_vm._v(_vm._s(item.text))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }